import * as React from "react"

const KtpRejc = (props) => (
  <svg
    width={161}
    height={105}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <rect x={6} y={12.294} width={143} height={83.294} rx={4} fill="#fff" />
      <rect
        x={36.222}
        y={22.613}
        width={86.979}
        height={4.423}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={36.222}
        y={29.985}
        width={86.979}
        height={8.108}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={48.412}
        width={27.273}
        height={9.582}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={63.892}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={72.737}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={81.582}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={48.412}
        width={58.232}
        height={9.582}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={63.892}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={72.737}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={81.582}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <path
        d="M136.03 77.294c-3.383-1.338-4.464-2.467-4.464-4.885 0-1.452 1.108-2.392 1.486-3.636.378-1.243.597-2.716.778-3.787.182-1.071.254-1.486.353-2.627.121-1.424-.757-5.101-5.453-5.101-4.695 0-5.576 3.677-5.453 5.101.099 1.141.172 1.556.353 2.627.181 1.071.398 2.543.775 3.787.378 1.244 1.488 2.184 1.488 3.636 0 2.418-1.081 3.547-4.464 4.885-3.395 1.34-5.599 2.663-5.599 3.597v4.377h25.799v-4.377c0-.932-2.205-2.255-5.599-3.597Z"
        fill="#8499A9"
      />
    </g>
    <path
      d="M158.178 9.931c-.356-.365-.722-.75-.862-1.078-.141-.328-.132-.815-.141-1.312-.009-.91-.028-1.95-.75-2.672-.722-.722-1.762-.74-2.672-.75-.497-.01-1.003-.019-1.312-.14-.31-.123-.713-.507-1.079-.863-.646-.62-1.387-1.322-2.362-1.322-.975 0-1.716.703-2.362 1.322-.366.356-.75.722-1.079.862-.328.14-.815.131-1.312.14-.909.01-1.95.029-2.672.75-.722.723-.741 1.763-.75 2.673-.009.497-.019 1.003-.141 1.312-.122.31-.506.713-.862 1.078-.619.647-1.322 1.388-1.322 2.363 0 .975.703 1.715 1.322 2.362.356.366.722.75.862 1.078.141.329.132.816.141 1.313.009.91.028 1.95.75 2.672.722.722 1.763.74 2.672.75.497.01 1.003.019 1.312.14.31.122.713.507 1.079.863.646.619 1.387 1.322 2.362 1.322.975 0 1.716-.703 2.362-1.322.366-.356.75-.722 1.079-.863.328-.14.815-.13 1.312-.14.91-.01 1.95-.028 2.672-.75.722-.722.741-1.763.75-2.672.009-.497.019-1.003.141-1.313.122-.309.506-.712.862-1.078.619-.647 1.322-1.387 1.322-2.362 0-.975-.703-1.716-1.322-2.363Zm-9.928-2.137a.749.749 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0v-5.25Zm.75 9.75a1.124 1.124 0 1 1 0-2.248 1.124 1.124 0 0 1 0 2.248Z"
      fill="#CF000F"
    />
    <defs>
      <filter
        id="a"
        x={0}
        y={9.294}
        width={155}
        height={95.294}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.239688 0 0 0 0 0.310242 0 0 0 0 0.491667 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_6243"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_939_6243"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default KtpRejc
